import clsx from 'clsx'
import styles from './Spinner.module.scss'

interface SpinnerProps {
  size?: 'default' | 'small'
  className?: string
}

export function Spinner({ size = 'default', className }: SpinnerProps): React.JSX.Element {
  return (
    <span
      className={clsx(
        styles.loader,
        size === 'small' && 'after:[border-[2px]] h-6 w-6 border-[2px]',
        size === 'default' && 'h-10 w-10',
        className
      )}
    />
  )
}
